'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Hack = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _reactRouterDom = require('react-router-dom');

var _MoreDropDown = require('./MoreDropDown');

var _MoreDropDown2 = _interopRequireDefault(_MoreDropDown);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Hack = exports.Hack = function (_React$Component) {
  (0, _inherits3.default)(Hack, _React$Component);

  function Hack() {
    (0, _classCallCheck3.default)(this, Hack);
    return (0, _possibleConstructorReturn3.default)(this, (Hack.__proto__ || (0, _getPrototypeOf2.default)(Hack)).apply(this, arguments));
  }

  (0, _createClass3.default)(Hack, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          history = _props.history,
          location = _props.location,
          passThrough = (0, _objectWithoutProperties3.default)(_props, ['history', 'location']);


      return React.createElement(_MoreDropDown2.default, (0, _extends3.default)({
        history: history,
        location: location
      }, passThrough));
    }
  }]);
  return Hack;
}(React.Component);

/**
 * There is currently an issue combining MUI's `withStyles`
 * and react-router-dom's `withRouter`. The issue is being
 * tracked here:
 *
 * https://github.com/digiaonline/react-flow-types/issues/12#issuecomment-337336269
 *
 * Once that is resolved, `withRouter` can be moved into `MoreDropDown.js`
 * and `Hack.js` can be deleted without breaking API changes.
 */

exports.default = (0, _reactRouterDom.withRouter)(Hack);